import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { SvgVM } from 'src/app/shared/models/model/concretes/components/svg.model';
import { SvgService } from 'src/app/shared/services/svg.service';

@Component({
  selector: 'app-svg-viewer',
  templateUrl: './svg-viewer.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class SvgViewerComponent implements OnInit {
  @Input() svg!: SvgVM;

  @Input() size!: number | undefined;

  @ViewChild('svgContainer', { static: true }) svgContainer!: ElementRef;

  constructor(
    private svgService: SvgService,
    private renderer: Renderer2,
  ) {}

  ngOnInit() {
    if (this.svg.urlFile) this.loadSvg(this.svg.urlFile);
  }

  loadSvg(path: string) {
    this.svgService.getSvg(path).subscribe((svg: string) => {
      const container = this.svgContainer.nativeElement;
      container.innerHTML = svg;
      this.setImageAttributes();
      this.setSvgColor(this.svg.isActive ? this.svg.colorActive : this.svg.color);
      if (this.size != undefined) this.setSvgSize();
    });
  }

  changeColor() {
    this.setSvgColor(this.svg.isActive ? this.svg.colorActive : this.svg.color);
  }

  onMouseEnter() {
    this.setSvgColor(this.svg.colorActive);
  }

  private setSvgColor(color: string) {
    if (!color || color === 'none' || color === 'original') return;

    const svgElements = Array.from(
      this.svgContainer.nativeElement.querySelectorAll('path, circle, rect, polygon, ellipse, line, polyline'),
    ) as SVGElement[];

    const hasCurrentColor = svgElements.some((svgElement) => {
      const fillAttr = svgElement.getAttribute('fill')?.toLowerCase() || svgElement.style.fill?.toLowerCase();
      const strokeAttr = svgElement.getAttribute('stroke')?.toLowerCase() || svgElement.style.stroke?.toLowerCase();
      return fillAttr === 'currentcolor' || strokeAttr === 'currentcolor';
    });

    svgElements.forEach((svgElement) => {
      const style = getComputedStyle(svgElement);
      const fillAttr = svgElement.getAttribute('fill')?.toLowerCase() || svgElement.style.fill?.toLowerCase();
      const strokeAttr = svgElement.getAttribute('stroke')?.toLowerCase() || svgElement.style.stroke?.toLowerCase();

      if (hasCurrentColor) {
        if (fillAttr === 'currentcolor') {
          this.renderer.setStyle(svgElement, 'fill', color);
        }
        if (strokeAttr === 'currentcolor') {
          this.renderer.setStyle(svgElement, 'stroke', color);
        }
      } else {
        if (style.fill && style.fill !== 'none' && style.fill !== 'rgba(0, 0, 0, 0)' && style.fill !== 'transparent') {
          this.renderer.setStyle(svgElement, 'fill', color);
        }
        if (
          style.stroke &&
          style.stroke !== 'none' &&
          style.stroke !== 'rgba(0, 0, 0, 0)' &&
          style.stroke !== 'transparent'
        ) {
          this.renderer.setStyle(svgElement, 'stroke', color);
        }
      }
    });
  }

  private setSvgSize() {
    const svgElements = this.svgContainer.nativeElement.querySelectorAll('svg');
    svgElements.forEach((svgElement: SVGPathElement) => {
      this.renderer.setStyle(svgElement, 'width', this.size);
      this.renderer.setStyle(svgElement, 'height', this.size);
    });
  }

  private setImageAttributes() {
    const svgElements = this.svgContainer.nativeElement.querySelectorAll('svg');
    svgElements.forEach((svgElement: SVGPathElement) => {
      this.renderer.setAttribute(svgElement, 'alt', '');
      this.renderer.setAttribute(svgElement, 'role', 'img');
      this.renderer.setAttribute(svgElement, 'aria-hidden', 'true');
      this.renderer.setAttribute(svgElement, 'preserveAspectRatio', 'xMidYMid meet');
    });
  }
}
